// Usage: In invite modal
<template>
  <div v-click-outside="clickOutsideContextMenu">
    <div @click="() => { showRoleSelectionContextMenu = !showRoleSelectionContextMenu }">
      <aha-input
        readonly
        :value="getRole()"
        class="role-value-input"
        :class="{
          'text-primary-90': showRoleSelectionContextMenu
        }"
      >
        <template #append>
          <aha-icon
            name="arrow"
            class="down-arrow absolute top-3.5 right-2"
            :class="{
              'text-primary-90': (showRoleSelectionContextMenu),
            }"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          />
        </template>
      </aha-input>
    </div>
    <div
      v-show="showRoleSelectionContextMenu"
      class="context-menu-role"
    >
      <ul>
        <li
          v-if="isTeamOwner"
          class="context-menu-item"
          @click="changeInvitedRole('admin')"
        >
          <aha-icon
            :class="{'invisible': invitedRole !== 'admin'}"
            name="check"
            class="text-primary-90"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>Admin</span>
        </li>
        <li
          class="context-menu-item"
          @click="changeInvitedRole('editor')"
        >
          <aha-icon
            :class="{'invisible': invitedRole !== 'editor'}"
            name="check"
            class="text-primary-90"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>Can edit</span>
        </li>
        <li
          class="context-menu-item"
          @click="changeInvitedRole('viewer')"
        >
          <aha-icon
            :class="{'invisible': invitedRole !== 'viewer'}"
            name="check"
            class="text-primary-90"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>Can view</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Util from '@/util'
import constants from '@/constant'

export default {
  props: {
    invitedRole: {
      type: String,
      default: 'editor', // editor / viewer
    },
  },
  data() {
    return {
      showRoleSelectionContextMenu: false,
    }
  },
  computed: {
    isTeamOwner() {
      return this.$store.state.currentUser.accountRole === constants.workspace.OWNER
    },
  },
  methods: {
    changeInvitedRole(role) {
      this.$emit('changeInvitedRole', role)
      this.showRoleSelectionContextMenu = false
      const isSelfCreatedTeam = (this.$store.state.currentAccount.createdFrom === 'presenter') || null
      Util.trackGA4AndMixpanel('Select role', {
        eventAction: 'Team management > Invite member > Select role',
        eventCategory: 'My Team',
        eventLabel: role,
        plan: this.$store.state.currentUser.plan,
        isSelfCreatedTeam,
      })
    },
    getRole() {
      if (this.invitedRole === 'admin') return 'Admin'
      if (this.invitedRole === 'viewer') return 'Can view'
      return 'Can edit'
    },
    clickOutsideContextMenu() {
      this.showRoleSelectionContextMenu = false
    },
  },
}
</script>
<style scoped lang='scss'>
.context-menu-role {
  @apply flex flex-col items-start fixed p-1 mt-4;
  border: 1px solid rgba(235, 235, 235, 1);
  z-index: 9999;
  background: #FFFFFF;
  box-shadow: 3px 3px 5px 0px rgba(210, 214, 224, 0.42);
  border-radius: 0.375rem;
}
::v-deep .aha-input {
  cursor: pointer;
}
.role-value-input {
  &:hover {
    @apply text-primary-90;
    .down-arrow {
      @apply text-primary-90;
    }
  }
}

</style>
